module.exports = __webpack_public_path__ + "media/images/gradient-309f503867cdd295bc6d413233df7eea.png";